@if (!mobileQuery.matches) {
  <mat-toolbar class="toolbar">
    <div class="example-toolbar">
      <ng-content select="[toolbar]"></ng-content>
    </div>
  </mat-toolbar>
}

<mat-sidenav-container class="example-sidenav-container">
  <mat-sidenav-content class="full-page">
    <ng-content select="[content]"></ng-content>
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>

@if (mobileQuery.matches) {
  <mat-toolbar class="footer">
    <ng-content select="[footer]"></ng-content>
  </mat-toolbar>
}
